import $ from 'jquery';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { helpers } from '@bingads-webui/projection-grid-toolbar';

const { crossPageSelectHeadRow } = globalContext.require('component/bingads-grid/plugin/cross-page-select-all/index');
const i18n = globalContext.require('component/i18n/loader!campaignui/feature/hotel-center');

export default class HotelOptionsBase {
  constructor() {
    this.i18n = i18n;
    const pageSizes = [10, 20, 50, 100];

    this.tableClasses = ['table', 'table-bordered'];
    this.scrolling = {
      virtualized: true,
      viewport: window,
      header: {
        type: 'sticky',
        offset() {
          return $('.navbar-fixed-top').height();
        },
      },
    };

    this.selection = {
      enabled: true,
    };

    this.rows = {
      headRows: [
        helpers.singleToolbarHeadRows(),
        crossPageSelectHeadRow(),
        'column-header-rows',
      ],
    };

    this.plugins = {
      pagination: {
        pageSize: 10,
        availablePageSizes: pageSizes,
        enableRandomPage: false,
        pageSizeText: i18n.getString('Grid_ShowRows'),
        totalPageCountText: i18n.getString('Grid_PageOf'),
      },
      uiBlocker: {
        el: $('.hotel-associations__container'),
        text: i18n.getString('Loading'),
      },
    };
  }
}
